import { Component } from '@angular/core';
import { AppService } from '@app/app.service';

@Component({
  selector: 'app-terms-of-service',
  imports: [],
  templateUrl: './terms-of-service.component.html',
  styleUrl: './terms-of-service.component.scss',
})
export class TermsOfServiceComponent {

  document: any = null;

  constructor(
    private appService: AppService
  ) { }

  ngOnInit() {
    this.getDocument();
  }

  getDocument(): void {

    this.appService.getDocument('terms-of-service').subscribe({
      next: (res) => {
        this.document = res.data;
      },
      error: (err) => {
        this.document = null;
      },
    });
  }

}
